var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"items":_vm.listings,"fields":[
    {key: 'id', label: 'Id'},
    {key: 'name', label: 'Name'},
    {key: 'select', label: 'Select'} ]},scopedSlots:_vm._u([{key:"cell(select)",fn:function(data){return [_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.onRemoval(data)}}},[_vm._v("\n      Remove\n    ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }